import { teamTable } from '@digitale-verhuurders-verklaring/rds/src/schema/team.sql';
import { createSelectSchema } from 'drizzle-zod';
import { z } from 'zod';

import { userDetailSchema } from './user';

export const teamSchema = createSelectSchema(teamTable);
/** Uses z.lazy to break circular dependency: user → team → user. */
export const teamDetailSchema = teamSchema.merge(
  z.object({
    users: z.array(z.lazy(() => userDetailSchema)),
  }),
);
export const teamInsertSchema = teamSchema.pick({
  name: true,
  locationId: true,
  externalIdentifier: true,
});
export const teamUpdateSchema = teamSchema.pick({
  id: true,
  name: true,
  locationId: true,
  externalIdentifier: true,
});
export const teamDeleteSchema = teamSchema.pick({
  id: true,
  name: true,
  locationId: true,
  deleted: true,
  deletedAt: true,
});
export const teamWithLocationNameAndUserAmountSchema = teamSchema.merge(
  z.object({
    locationName: z.string(),
    userAmount: z.number(),
  }),
);

export type Team = z.infer<typeof teamSchema>;
export type TeamDetail = z.infer<typeof teamDetailSchema>;
export type TeamWithLocationNameAndUserAmount = z.infer<
  typeof teamWithLocationNameAndUserAmountSchema
>;
export type TeamInsert = z.infer<typeof teamInsertSchema>;
export type TeamUpdate = z.infer<typeof teamUpdateSchema>;
export type TeamDelete = z.infer<typeof teamDeleteSchema>;

export const teamAddRequestSchema = teamInsertSchema.pick({
  locationId: true,
});
export type TeamAddRequest = z.infer<typeof teamAddRequestSchema>;
export const teamDeleteRequestSchema = teamDeleteSchema.pick({
  id: true,
});
export type TeamDeleteRequest = z.infer<typeof teamDeleteRequestSchema>;

export const teamModalDataSchema = z.union([
  z.object({
    type: z.literal('add'),
    data: teamAddRequestSchema,
  }),
  z.object({
    type: z.literal('edit'),
    data: teamUpdateSchema,
  }),
  z.object({
    type: z.literal('delete'),
    data: teamDeleteSchema,
  }),
]);

export type TeamModalData = z.infer<typeof teamModalDataSchema>;
